import {Component} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.css'],
    imports: [
        MatProgressSpinner
    ],
    standalone: true
})
export class ProgressComponent {
    visible = false;

    constructor() {
    }

    setVisible(value: boolean) {
        this.visible = value;
    }
}
